import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

class SubscriptionCanceled extends Component {
    render() {
        return (
            <div className={styles.container}>
                <div className={styles.content}>
                    <h1>Subscription Canceled</h1>
                    <p>Your subscription process was canceled.</p>
                    <p>If you change your mind, you can subscribe at any time.</p>

                    <div className={styles.buttonGroup}>
                        <Link to="/subscription/checkout" className={styles.retryButton}>
                            Try Again
                        </Link>
                        <Link to="/athletes" className={styles.homeButton}>
                            Go to Dashboard
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default SubscriptionCanceled;
